export const UPDATE_LOADING_MENU = 'UPDATE_LOADING_MENU';
export const UPDATE_ERROR_MENU = 'UPDATE_ERROR_MENU';
export const UPDATE_MENU = 'UPDATE_MENU';